// @flow

import _ from 'lodash/fp';
import {GET, POST, PUT} from '../helpers/request';
import {ADD as NOTIFICATION} from './notification';
import {STANDARD} from '../assortments';
import {
  filterAndSort,
  sortByName,
} from './apartmentConfigView';
import type {Dispatch} from 'redux';
import type {Exact} from '../reducers/configTemplateView';
import type {OptionalNavigationAction} from './notification';
import type {
  ConfigTemplateDto,
  ErrorDto,
  ProductDto,
  ProductSlotDto,
  ProductTypeDto,
  RoomDto,
  RoomTypeDto,
  VariantDto,
  LimitedProjectDto,
  RoomTemplateDto,
} from '../dtos';

export const GET_REQUEST = '@configTemplateView/GET_REQUEST';
export const GET_SUCCESS = '@configTemplateView/GET_SUCCESS';
export const GET_FAILURE = '@configTemplateView/GET_FAILURE';

export const UPDATE_REQUEST = '@configTemplateView/UPDATE_REQUEST';
export const UPDATE_SUCCESS = '@configTemplateView/UPDATE_SUCCESS';
export const UPDATE_FAILURE = '@configTemplateView/UPDATE_FAILURE';

export const CREATE_REQUEST = '@configTemplateView/CREATE_REQUEST';
export const CREATE_SUCCESS = '@configTemplateView/CREATE_SUCCESS';
export const CREATE_FAILURE = '@configTemplateView/CREATE_FAILURE';

export const ROOM_UPDATE_REQUEST = '@configTemplateView/ROOM_UPDATE_REQUEST';
export const ROOM_UPDATE_SUCCESS = '@configTemplateView/ROOM_UPDATE_SUCCESS';
export const ROOM_UPDATE_FAILURE = '@configTemplateView/ROOM_UPDATE_FAILURE';

export const ROOM_CREATE_REQUEST = '@configTemplateView/ROOM_CREATE_REQUEST';
export const ROOM_CREATE_SUCCESS = '@configTemplateView/ROOM_CREATE_SUCCESS';
export const ROOM_CREATE_FAILURE = '@configTemplateView/ROOM_CREATE_FAILURE';

export const PRODUCT_SLOT_UPDATE_REQUEST = '@configTemplateView/PRODUCT_SLOT_UPDATE_REQUEST';
export const PRODUCT_SLOT_UPDATE_SUCCESS = '@configTemplateView/PRODUCT_SLOT_UPDATE_SUCCESS';
export const PRODUCT_SLOT_UPDATE_FAILURE = '@configTemplateView/PRODUCT_SLOT_UPDATE_FAILURE';

export const PRODUCT_SLOT_CREATE_REQUEST = '@configTemplateView/PRODUCT_SLOT_CREATE_REQUEST';
export const PRODUCT_SLOT_CREATE_SUCCESS = '@configTemplateView/PRODUCT_SLOT_CREATE_SUCCESS';
export const PRODUCT_SLOT_CREATE_FAILURE = '@configTemplateView/PRODUCT_SLOT_CREATE_FAILURE';

export const SELECT_ROOM = '@configTemplateView/SELECT_ROOM';
export const SELECT_PRODUCT_SLOT = '@configTemplateView/SELECT_PRODUCT_SLOT';
export const RESET = '@configTemplateView/RESET';
export const CLEAR = '@configTemplateView/CLEAR';

export const OPEN_DIALOG_REQUEST = '@configTemplateView/OPEN_DIALOG_REQUEST';
export const OPEN_DIALOG_FAILURE = '@configTemplateView/OPEN_DIALOG_FAILURE';
export const OPEN_DIALOG_SUCCESS = '@configTemplateView/OPEN_DIALOG_SUCCESS';
export const CLOSE_DIALOG = '@configTemplateView/CLOSE_DIALOG';
export const POP_DIALOG_NAVIGATION = '@configTemplateView/POP_DIALOG_NAVIGATION';
export const NAVIGATE_TO_VARIANT_REQUEST = '@configTemplateView/NAVIGATE_TO_VARIANT_REQUEST';
export const NAVIGATE_TO_VARIANT_FAILURE = '@configTemplateView/NAVIGATE_TO_VARIANT_FAILURE';
export const NAVIGATE_TO_VARIANT_SUCCESS = '@configTemplateView/NAVIGATE_TO_VARIANT_SUCCESS';
export const UPDATE_RELATED_VARIANT = '@configTemplateView/UPDATE_RELATED_VARIANT';
export const TOGGLE_VARIANT_REQUEST = '@configTemplateView/TOGGLE_VARIANT_REQUEST';
export const TOGGLE_VARIANT_FAILURE = '@configTemplateView/TOGGLE_VARIANT_FAILURE';
export const TOGGLE_VARIANT_SUCCESS = '@configTemplateView/TOGGLE_VARIANT_SUCCESS';
export const SET_STANDARD_PRODUCT = '@configTemplateView/SET_STANDARD_PRODUCT';
export const TOGGLE_PRODUCT = '@configTemplateView/TOGGLE_PRODUCT';
export const CHECK_ALL_VARIANTS = '@configTemplateView/CHECK_ALL_VARIANTS';
export const CLEAR_STANDARD_PRODUCT = '@configTemplateView/CLEAR_STANDARD_PRODUCT';
export const CHECK_PRODUCT = '@configTemplateView/CHECK_PRODUCT';
export const UPDATE_VARIANTS = '@configTemplateView/UPDATE_VARIANTS';
export const ROOMS_UPDATE_REQUEST = '@configTemplateView/ROOMS_UPDATE_REQUEST';
export const ROOMS_UPDATE_FAILURE = '@configTemplateView/ROOMS_UPDATE_FAILURE';
export const ROOMS_UPDATE_SUCCESS = '@configTemplateView/ROOMS_UPDATE_SUCCESS';
export const PRODUCT_SLOTS_UPDATE_REQUEST = '@configTemplateView/PRODUCT_SLOTS_UPDATE_REQUEST';
export const PRODUCT_SLOTS_UPDATE_FAILURE = '@configTemplateView/PRODUCT_SLOTS_UPDATE_FAILURE';
export const PRODUCT_SLOTS_UPDATE_SUCCESS = '@configTemplateView/PRODUCT_SLOTS_UPDATE_SUCCESS';
export const UPDATE_VARIANTS_FOR_TYPE = '@configTemplateView/UPDATE_VARIANTS_FOR_TYPE';

export type ConfigTemplateGetRequestAction = OptionalNavigationAction & {
  type: '@configTemplateView/GET_REQUEST',
};
export type ConfigTemplateGetSuccessAction = OptionalNavigationAction & {
  type: '@configTemplateView/GET_SUCCESS',
  configTemplate: ?ConfigTemplateDto,
  roomTypes: RoomTypeDto[],
  products: ProductDto[],
  productTypes: ProductTypeDto[],
  configTemplates: ConfigTemplateDto[],
  projects: LimitedProjectDto[],
  roomTemplates: RoomTemplateDto[],
};
export type ConfigTemplateGetFailureAction = OptionalNavigationAction & {
  type: '@configTemplateView/GET_FAILURE',
  error: ErrorDto,
};

export type ConfigTemplateUpdateRequestAction = OptionalNavigationAction & {
  type: '@configTemplateView/UPDATE_REQUEST',
};
export type ConfigTemplateUpdateSuccessAction = OptionalNavigationAction & {
  type: '@configTemplateView/UPDATE_SUCCESS',
  configTemplate: ConfigTemplateDto,
};
export type ConfigTemplateUpdateFailureAction = OptionalNavigationAction & {
  type: '@configTemplateView/UPDATE_FAILURE',
  error: ErrorDto,
};

export type ConfigTemplateCreateRequestAction = OptionalNavigationAction & {
  type: '@configTemplateView/CREATE_REQUEST',
};
export type ConfigTemplateCreateSuccessAction = OptionalNavigationAction & {
  type: '@configTemplateView/CREATE_SUCCESS',
  configTemplate: ConfigTemplateDto,
};
export type ConfigTemplateCreateFailureAction = OptionalNavigationAction & {
  type: '@configTemplateView/CREATE_FAILURE',
  error: ErrorDto,
};

export type ConfigTemplateRoomUpdateRequestAction = OptionalNavigationAction & {
  type: '@configTemplateView/ROOM_UPDATE_REQUEST',
};
export type ConfigTemplateRoomUpdateSuccessAction = OptionalNavigationAction & {
  type: '@configTemplateView/ROOM_UPDATE_SUCCESS',
  room: RoomDto,
};
export type ConfigTemplateRoomUpdateFailureAction = OptionalNavigationAction & {
  type: '@configTemplateView/ROOM_UPDATE_FAILURE',
  error: ErrorDto,
};

export type ConfigTemplateRoomCreateRequestAction = OptionalNavigationAction & {
  type: '@configTemplateView/ROOM_CREATE_REQUEST',
};
export type ConfigTemplateRoomCreateSuccessAction = OptionalNavigationAction & {
  type: '@configTemplateView/ROOM_CREATE_SUCCESS',
  room: RoomDto,
};
export type ConfigTemplateRoomCreateFailureAction = OptionalNavigationAction & {
  type: '@configTemplateView/ROOM_CREATE_FAILURE',
  error: ErrorDto,
};

export type ConfigTemplateProductSlotUpdateRequestAction = OptionalNavigationAction & {
  type: '@configTemplateView/PRODUCT_SLOT_UPDATE_REQUEST',
};
export type ConfigTemplateProductSlotUpdateSuccessAction = OptionalNavigationAction & {
  type: '@configTemplateView/PRODUCT_SLOT_UPDATE_SUCCESS',
  productSlot: ProductSlotDto,
};
export type ConfigTemplateProductSlotUpdateFailureAction = OptionalNavigationAction & {
  type: '@configTemplateView/PRODUCT_SLOT_UPDATE_FAILURE',
  error: ErrorDto,
};

export type ConfigTemplateProductSlotCreateRequestAction = OptionalNavigationAction & {
  type: '@configTemplateView/PRODUCT_SLOT_CREATE_REQUEST',
};
export type ConfigTemplateProductSlotCreateSuccessAction = OptionalNavigationAction & {
  type: '@configTemplateView/PRODUCT_SLOT_CREATE_SUCCESS',
  productSlot: ProductSlotDto,
  roomId: number,
};
export type ConfigTemplateProductSlotCreateFailureAction = OptionalNavigationAction & {
  type: '@configTemplateView/PRODUCT_SLOT_CREATE_FAILURE',
  error: ErrorDto,
};

export type ConfigTemplateSelectRoomAction = OptionalNavigationAction & {
  type: '@configTemplateView/SELECT_ROOM',
  room: ?RoomDto,
};
export type ConfigTemplateSelectProductSlotAction = OptionalNavigationAction & {
  type: '@configTemplateView/SELECT_PRODUCT_SLOT',
  roomId: number,
  productSlot: ?ProductSlotDto,
};
export type ConfigTemplateResetAction = OptionalNavigationAction & {
  type: '@configTemplateView/RESET',
};
export type ConfigTemplateClearAction = OptionalNavigationAction & {
  type: '@configTemplateView/CLEAR',
};

export type ConfigTemplateOpenDialogRequestAction = OptionalNavigationAction & {
  type: '@configTemplateView/OPEN_DIALOG_REQUEST',
};
export type ConfigTemplateOpenDialogFailureAction = OptionalNavigationAction & {
  type: '@configTemplateView/OPEN_DIALOG_FAILURE',
  error: ErrorDto,
};
export type ConfigTemplateOpenDialogSuccessAction = OptionalNavigationAction & {
  type: '@configTemplateView/OPEN_DIALOG_SUCCESS',
  products: ProductDto[],
  rootName: string,
  productType: ProductTypeDto,
};
export type ConfigTemplateCloseDialogAction = OptionalNavigationAction & {
  type: '@configTemplateView/CLOSE_DIALOG',
};
export type ConfigTemplatePopDialogNavigationAction = OptionalNavigationAction & {
  type: '@configTemplateView/POP_DIALOG_NAVIGATION',
  depth: number,
};
export type ConfigTemplateNavigateToVariantRequestAction = OptionalNavigationAction & {
  type: '@configTemplateView/NAVIGATE_TO_VARIANT_REQUEST',
};
export type ConfigTemplateNavigateToVariantFailureAction = OptionalNavigationAction & {
  type: '@configTemplateView/NAVIGATE_TO_VARIANT_FAILURE',
  error: ErrorDto,
};
export type ConfigTemplateNavigateToVariantSuccessAction = OptionalNavigationAction & {
  type: '@configTemplateView/NAVIGATE_TO_VARIANT_SUCCESS',
  variant: VariantDto,
};
export type ConfigTemplateUpdateRelatedVariantAction = OptionalNavigationAction & {
  type: '@configTemplateView/UPDATE_RELATED_VARIANT',
  variant: VariantDto,
  data: any,
};
export type ConfigTemplateToggleVariantRequestAction = OptionalNavigationAction & {
  type: '@configTemplateView/TOGGLE_VARIANT_REQUEST',
};
export type ConfigTemplateToggleVariantFailureAction = OptionalNavigationAction & {
  type: '@configTemplateView/TOGGLE_VARIANT_FAILURE',
  error: ErrorDto,
};
export type ConfigTemplateToggleVariantSuccessAction = OptionalNavigationAction & {
  type: '@configTemplateView/TOGGLE_VARIANT_SUCCESS',
  variant: VariantDto,
  expand: boolean,
};
export type ConfigTemplateSetStandardProductAction = OptionalNavigationAction & {
  type: '@configTemplateView/SET_STANDARD_PRODUCT',
  product: ProductDto,
  productType: ProductTypeDto,
};
export type ConfigTemplateToggleProductAction = OptionalNavigationAction & {
  type: '@configTemplateView/TOGGLE_PRODUCT',
  product: ProductDto,
};
export type ConfigTemplateCheckAllVariantsAction = OptionalNavigationAction & {
  type: '@configTemplateView/CHECK_ALL_VARIANTS',
  checked: boolean,
};
export type ConfigTemplateClearStandardProductAction = OptionalNavigationAction & {
  type: '@configTemplateView/CLEAR_STANDARD_PRODUCT',
  productType: ProductTypeDto,
};
export type ConfigTemplateCheckProductAction = OptionalNavigationAction & {
  type: '@configTemplateView/CHECK_PRODUCT',
  productId: number,
  checked: boolean,
};
export type ConfigTemplateUpdateVariantsAction = OptionalNavigationAction & {
  type: '@configTemplateView/UPDATE_VARIANTS',
  productId: number,
  data: any,
};
export type ConfigTemplateUpdateVariantsForTypeAction = OptionalNavigationAction & {
  type: '@configTemplateView/UPDATE_VARIANTS_FOR_TYPE',
  productTypeId: number,
  data: any,
};
export type ConfigTemplateRoomsUpdateRequestAction = OptionalNavigationAction & {
  type: '@configTemplateView/ROOMS_UPDATE_REQUEST',
};
export type ConfigTemplateRoomsUpdateFailureAction = OptionalNavigationAction & {
  type: '@configTemplateView/ROOMS_UPDATE_FAILURE',
  error: ErrorDto,
};
export type ConfigTemplateRoomsUpdateSuccessAction = OptionalNavigationAction & {
  type: '@configTemplateView/ROOMS_UPDATE_SUCCESS',
  rooms: RoomDto[],
};
export type ConfigTemplateProductSlotsUpdateRequestAction = OptionalNavigationAction & {
  type: '@configTemplateView/PRODUCT_SLOTS_UPDATE_REQUEST',
};
export type ConfigTemplateProductSlotsUpdateFailureAction = OptionalNavigationAction & {
  type: '@configTemplateView/PRODUCT_SLOTS_UPDATE_FAILURE',
  error: ErrorDto,
};
export type ConfigTemplateProductSlotsUpdateSuccessAction = OptionalNavigationAction & {
  type: '@configTemplateView/PRODUCT_SLOTS_UPDATE_SUCCESS',
  roomId: number,
  productSlotId: number,
  productSlots: ProductSlotDto[],
};

export type ConfigTemplateAction
  = ConfigTemplateGetRequestAction
  | ConfigTemplateGetSuccessAction
  | ConfigTemplateGetFailureAction
  | ConfigTemplateUpdateRequestAction
  | ConfigTemplateUpdateSuccessAction
  | ConfigTemplateUpdateFailureAction
  | ConfigTemplateCreateRequestAction
  | ConfigTemplateCreateSuccessAction
  | ConfigTemplateCreateFailureAction
  | ConfigTemplateRoomUpdateRequestAction
  | ConfigTemplateRoomUpdateSuccessAction
  | ConfigTemplateRoomUpdateFailureAction
  | ConfigTemplateRoomCreateRequestAction
  | ConfigTemplateRoomCreateSuccessAction
  | ConfigTemplateRoomCreateFailureAction
  | ConfigTemplateProductSlotUpdateRequestAction
  | ConfigTemplateProductSlotUpdateSuccessAction
  | ConfigTemplateProductSlotUpdateFailureAction
  | ConfigTemplateProductSlotCreateRequestAction
  | ConfigTemplateProductSlotCreateSuccessAction
  | ConfigTemplateProductSlotCreateFailureAction
  | ConfigTemplateSelectRoomAction
  | ConfigTemplateSelectProductSlotAction
  | ConfigTemplateResetAction
  | ConfigTemplateClearAction
  | ConfigTemplateOpenDialogRequestAction
  | ConfigTemplateOpenDialogFailureAction
  | ConfigTemplateOpenDialogSuccessAction
  | ConfigTemplateCloseDialogAction
  | ConfigTemplatePopDialogNavigationAction
  | ConfigTemplateNavigateToVariantRequestAction
  | ConfigTemplateNavigateToVariantFailureAction
  | ConfigTemplateNavigateToVariantSuccessAction
  | ConfigTemplateUpdateRelatedVariantAction
  | ConfigTemplateToggleVariantRequestAction
  | ConfigTemplateToggleVariantFailureAction
  | ConfigTemplateToggleVariantSuccessAction
  | ConfigTemplateSetStandardProductAction
  | ConfigTemplateToggleProductAction
  | ConfigTemplateCheckAllVariantsAction
  | ConfigTemplateClearStandardProductAction
  | ConfigTemplateCheckProductAction
  | ConfigTemplateUpdateVariantsAction
  | ConfigTemplateUpdateVariantsForTypeAction
  | ConfigTemplateRoomsUpdateRequestAction
  | ConfigTemplateRoomsUpdateFailureAction
  | ConfigTemplateRoomsUpdateSuccessAction
  | ConfigTemplateProductSlotsUpdateRequestAction
  | ConfigTemplateProductSlotsUpdateFailureAction
  | ConfigTemplateProductSlotsUpdateSuccessAction;

const roomsUpdateRequest = (): Exact<ConfigTemplateRoomsUpdateRequestAction> => ({
  type: ROOMS_UPDATE_REQUEST,
});

const roomsUpdateFailure = (error: ErrorDto): Exact<ConfigTemplateRoomsUpdateFailureAction> => ({
  type: ROOMS_UPDATE_FAILURE,
  error,
});

const roomsUpdateSuccess = (rooms: RoomDto[]): Exact<ConfigTemplateRoomsUpdateSuccessAction> => ({
  type: ROOMS_UPDATE_SUCCESS,
  rooms,
});

const productSlotsUpdateRequest = (): Exact<ConfigTemplateProductSlotsUpdateRequestAction> => ({
  type: PRODUCT_SLOTS_UPDATE_REQUEST,
});

const productSlotsUpdateFailure = (error: ErrorDto): Exact<ConfigTemplateProductSlotsUpdateFailureAction> => ({
  type: PRODUCT_SLOTS_UPDATE_FAILURE,
  error,
});

const productSlotsUpdateSuccess = (roomId: number, productSlotId: number, productSlots: ProductSlotDto[]): Exact<ConfigTemplateProductSlotsUpdateSuccessAction> => ({
  type: PRODUCT_SLOTS_UPDATE_SUCCESS,
  roomId,
  productSlotId,
  productSlots,
});

export const updateVariants = (productId: number, data: any): Exact<ConfigTemplateUpdateVariantsAction> => ({
  type: UPDATE_VARIANTS,
  productId,
  data,
});

export const updateVariantsForType = (productTypeId: number, data: any): Exact<ConfigTemplateUpdateVariantsForTypeAction> => ({
  type: UPDATE_VARIANTS_FOR_TYPE,
  productTypeId,
  data,
});

export const checkProduct = (productId: number, checked: boolean): Exact<ConfigTemplateCheckProductAction> => ({
  type: CHECK_PRODUCT,
  productId,
  checked,
});

export const checkAllVariants = (checked: boolean): Exact<ConfigTemplateCheckAllVariantsAction> => ({
  type: CHECK_ALL_VARIANTS,
  checked,
});

export const toggleProduct = (product: ProductDto): Exact<ConfigTemplateToggleProductAction> => ({
  type: TOGGLE_PRODUCT,
  product,
});

export const popDialogNavigation = (depth: number): Exact<ConfigTemplatePopDialogNavigationAction> => ({
  type: POP_DIALOG_NAVIGATION,
  depth,
});

const navigateToVariantRequest = (): Exact<ConfigTemplateNavigateToVariantRequestAction> => ({
  type: NAVIGATE_TO_VARIANT_REQUEST,
});

const navigateToVariantFailure = (error: ErrorDto): Exact<ConfigTemplateNavigateToVariantFailureAction> => ({
  type: NAVIGATE_TO_VARIANT_FAILURE,
  error,
});

const navigateToVariantSuccess = (variant: VariantDto): Exact<ConfigTemplateNavigateToVariantSuccessAction> => ({
  type: NAVIGATE_TO_VARIANT_SUCCESS,
  variant,
});

export const navigateToVariant = (variant: VariantDto) => async (dispatch: Dispatch<ConfigTemplateAction>) => {
  dispatch(navigateToVariantRequest());
  try {
    const fullVariant = await GET({endpoint: `/productvariants/${variant.id}`}, dispatch);
    dispatch(navigateToVariantSuccess({
      ...fullVariant,
      uuid: variant.uuid,
    }));
  } catch (err) {
    dispatch(navigateToVariantFailure(err));
  }
};

export const updateRelatedVariant = (variant: VariantDto, data: any): Exact<ConfigTemplateUpdateRelatedVariantAction> => ({
  type: UPDATE_RELATED_VARIANT,
  variant,
  data,
});

export const setStandardProduct = (product: ProductDto, productType: ProductTypeDto): Exact<ConfigTemplateSetStandardProductAction> => ({
  type: SET_STANDARD_PRODUCT,
  product,
  productType,
});

export const clearStandardProduct = (productType: ProductTypeDto): Exact<ConfigTemplateClearStandardProductAction> => ({
  type: CLEAR_STANDARD_PRODUCT,
  productType,
});

const toggleVariantRequest = (): Exact<ConfigTemplateToggleVariantRequestAction> => ({
  type: TOGGLE_VARIANT_REQUEST,
});

const toggleVariantFailure = (error: ErrorDto): Exact<ConfigTemplateToggleVariantFailureAction> => ({
  type: TOGGLE_VARIANT_FAILURE,
  error,
});

const toggleVariantSuccess = (variant: VariantDto, expand: boolean): Exact<ConfigTemplateToggleVariantSuccessAction> => ({
  type: TOGGLE_VARIANT_SUCCESS,
  variant,
  expand,
});

export const toggleVariant = (variant: VariantDto, expand: boolean) => async (dispatch: Dispatch<ConfigTemplateAction>) => {
  if (expand) {
    dispatch(toggleVariantRequest());
    try {
      const fullVariant = await GET({endpoint: `/productvariants/${variant.id}`}, dispatch);
      dispatch(toggleVariantSuccess({
        ...fullVariant,
        uuid: variant.uuid,
      }, expand));
    } catch (err) {
      dispatch(toggleVariantFailure(err));
    }
  } else {
    dispatch(toggleVariantSuccess(variant, expand));
  }
};

const openDialogRequest = (): Exact<ConfigTemplateOpenDialogRequestAction> => ({
  type: OPEN_DIALOG_REQUEST,
});

const openDialogFailure = (error: ErrorDto): Exact<ConfigTemplateOpenDialogFailureAction> => ({
  type: OPEN_DIALOG_FAILURE,
  error,
});

const openDialogSuccess = (products: ProductDto[], rootName: string, productType: ProductTypeDto): Exact<ConfigTemplateOpenDialogSuccessAction> => ({
  type: OPEN_DIALOG_SUCCESS,
  products,
  rootName,
  productType,
});

export const openDialog = (productTypeId: number, rootName: string) => async (dispatch: Dispatch<ConfigTemplateAction>) => {
  dispatch(openDialogRequest());
  try {
    const productType = await GET({endpoint: `/producttypes/${productTypeId}`}, dispatch);
    const products = await GET({endpoint: `/products?productTypeId=${productTypeId}&assortment=${STANDARD}`}, dispatch);
    dispatch(openDialogSuccess(products, rootName, productType));
  } catch (err) {
    dispatch(openDialogFailure(err));
  }
};

export const closeDialog = (): Exact<ConfigTemplateCloseDialogAction> => ({
  type: CLOSE_DIALOG,
});

const configTemplateRequest = (): Exact<ConfigTemplateGetRequestAction> => ({
  type: GET_REQUEST,
});

const configTemplateSuccess = (configTemplate: ?ConfigTemplateDto, roomTypes: RoomTypeDto[], products: ProductDto[], productTypes: ProductTypeDto[], configTemplates: ConfigTemplateDto[], projects: LimitedProjectDto[], roomTemplates: RoomTemplateDto[]): Exact<ConfigTemplateGetSuccessAction> => ({
  type: GET_SUCCESS,
  configTemplate,
  roomTypes,
  products,
  productTypes,
  configTemplates,
  projects,
  roomTemplates,
});

const configTemplateFailure = (error: ErrorDto): Exact<ConfigTemplateGetFailureAction> => ({
  type: GET_FAILURE,
  error,
});

const configTemplateUpdateRequest = (): Exact<ConfigTemplateUpdateRequestAction> => ({
  type: UPDATE_REQUEST,
});

const configTemplateUpdateSuccess = (configTemplate: ConfigTemplateDto): Exact<ConfigTemplateUpdateSuccessAction> => ({
  type: UPDATE_SUCCESS,
  configTemplate,
  [NOTIFICATION]: {
    message: 'Mall uppdaterad',
  },
});

const configTemplateUpdateFailure = (error: ErrorDto): Exact<ConfigTemplateUpdateFailureAction> => ({
  type: UPDATE_FAILURE,
  error,
});

const configTemplateCreateRequest = (): Exact<ConfigTemplateCreateRequestAction> => ({
  type: CREATE_REQUEST,
});

const configTemplateCreateSuccess = (configTemplate: ConfigTemplateDto): Exact<ConfigTemplateCreateSuccessAction> => ({
  type: CREATE_SUCCESS,
  configTemplate,
  [NOTIFICATION]: {
    message: `Mall "${configTemplate.name}" skapad`,
  },
});

const configTemplateCreateFailure = (error: ErrorDto): Exact<ConfigTemplateCreateFailureAction> => ({
  type: CREATE_FAILURE,
  error,
});

const roomUpdateRequest = (): Exact<ConfigTemplateRoomUpdateRequestAction> => ({
  type: ROOM_UPDATE_REQUEST,
});

const roomUpdateSuccess = (room: RoomDto): Exact<ConfigTemplateRoomUpdateSuccessAction> => ({
  type: ROOM_UPDATE_SUCCESS,
  room,
  [NOTIFICATION]: {
    message: 'Rum uppdaterat',
  },
});

const roomUpdateFailure = (error: ErrorDto): Exact<ConfigTemplateRoomUpdateFailureAction> => ({
  type: ROOM_UPDATE_FAILURE,
  error,
});

const roomCreateRequest = (): Exact<ConfigTemplateRoomCreateRequestAction> => ({
  type: ROOM_CREATE_REQUEST,
});

const roomCreateSuccess = (room: RoomDto): Exact<ConfigTemplateRoomCreateSuccessAction> => ({
  type: ROOM_CREATE_SUCCESS,
  room,
  [NOTIFICATION]: {
    message: `Rum "${room.name}" skapat`,
  },
});

const roomCreateFailure = (error: ErrorDto): Exact<ConfigTemplateRoomCreateFailureAction> => ({
  type: ROOM_CREATE_FAILURE,
  error,
});

const productSlotUpdateRequest = (): Exact<ConfigTemplateProductSlotUpdateRequestAction> => ({
  type: PRODUCT_SLOT_UPDATE_REQUEST,
});

const productSlotUpdateSuccess = (productSlot: ProductSlotDto): Exact<ConfigTemplateProductSlotUpdateSuccessAction> => ({
  type: PRODUCT_SLOT_UPDATE_SUCCESS,
  productSlot,
  [NOTIFICATION]: {
    message: 'Produktplats uppdaterad',
  },
});

const productSlotUpdateFailure = (error: ErrorDto): Exact<ConfigTemplateProductSlotUpdateFailureAction> => ({
  type: PRODUCT_SLOT_UPDATE_FAILURE,
  error,
});

const productSlotCreateRequest = (): Exact<ConfigTemplateProductSlotCreateRequestAction> => ({
  type: PRODUCT_SLOT_CREATE_REQUEST,
});

const productSlotCreateSuccess = (productSlot: ProductSlotDto, roomId: number): Exact<ConfigTemplateProductSlotCreateSuccessAction> => ({
  type: PRODUCT_SLOT_CREATE_SUCCESS,
  productSlot,
  roomId,
  [NOTIFICATION]: {
    message: `Produktplats "${productSlot.name}" skapad`,
  },
});

const productSlotCreateFailure = (error: ErrorDto): Exact<ConfigTemplateProductSlotCreateFailureAction> => ({
  type: PRODUCT_SLOT_CREATE_FAILURE,
  error,
});

export const clear = (): Exact<ConfigTemplateClearAction> => ({
  type: CLEAR,
});

export const reset = (): Exact<ConfigTemplateResetAction> => ({
  type: RESET,
});

export const selectRoom = (room: ?RoomDto): Exact<ConfigTemplateSelectRoomAction> => ({
  type: SELECT_ROOM,
  room,
});

export const selectProductSlot = (roomId: number, productSlot: ?ProductSlotDto): Exact<ConfigTemplateSelectProductSlotAction> => ({
  type: SELECT_PRODUCT_SLOT,
  roomId,
  productSlot,
});

export const fetchData = (id: number) => async (dispatch: Dispatch<ConfigTemplateAction>) => {
  dispatch(configTemplateRequest());
  try {
    const roomTypes = sortByName(await GET({endpoint: '/roomtypes'}, dispatch));
    const products = await GET({endpoint: `/products?assortment=${STANDARD}`}, dispatch);
    const productTypes = sortByName(await GET({endpoint: '/producttypes'}, dispatch));
    const projects = sortByName(_.map(x => ({
      ...x,
      apartmentConfigs: sortByName(x.apartmentConfigs),
    }), await GET({endpoint: '/projects/rooms'}, dispatch)));
    const roomTemplates = filterAndSort(await GET({endpoint: '/roomtemplates'}, dispatch));
    let configTemplate = null;
    let configTemplates = [];
    if (id) {
      configTemplate = await GET({endpoint: `/configtemplates/${id}`}, dispatch);
    } else {
      configTemplates = filterAndSort(await GET({endpoint: '/configtemplates'}, dispatch));
    }
    dispatch(configTemplateSuccess(configTemplate, roomTypes, products, productTypes, configTemplates, projects, roomTemplates));
  } catch (err) {
    dispatch(configTemplateFailure(err));
  }
};

export const updateConfigTemplate = (id: number, body: any) => async (dispatch: Dispatch<ConfigTemplateAction>) => {
  dispatch(configTemplateUpdateRequest());
  try {
    const configTemplate = await PUT({
      endpoint: `/configtemplates/${id}`,
      body,
    }, dispatch);
    dispatch(configTemplateUpdateSuccess(configTemplate));
  } catch (err) {
    dispatch(configTemplateUpdateFailure(err));
  }
};

export const createConfigTemplate = (body: any) => async (dispatch: Dispatch<ConfigTemplateAction>) => {
  dispatch(configTemplateCreateRequest());
  try {
    const configTemplate = await POST({
      endpoint: '/configtemplates',
      body,
    }, dispatch);
    dispatch(configTemplateCreateSuccess(configTemplate));
  } catch (err) {
    dispatch(configTemplateCreateFailure(err));
  }
};

export const createRoom = (configId: number, body: any) => async (dispatch: Dispatch<ConfigTemplateAction>) => {
  dispatch(roomCreateRequest());
  try {
    const room = await POST({
      endpoint: `/configtemplates/${configId}/rooms`,
      body,
    }, dispatch);
    dispatch(roomCreateSuccess(room));
  } catch (err) {
    dispatch(roomCreateFailure(err));
  }
};

export const updateRoom = (id: number, body: any) => async (dispatch: Dispatch<ConfigTemplateAction>) => {
  dispatch(roomUpdateRequest());
  try {
    const room = await PUT({
      endpoint: `/rooms/${id}`,
      body,
    }, dispatch);
    dispatch(roomUpdateSuccess(room));
  } catch (err) {
    dispatch(roomUpdateFailure(err));
  }
};

export const createProductSlot = (roomId: number, body: any) => async (dispatch: Dispatch<ConfigTemplateAction>) => {
  dispatch(productSlotCreateRequest());
  try {
    const productslot = await POST({
      endpoint: `/rooms/${roomId}/productslots`,
      body,
    }, dispatch);
    dispatch(productSlotCreateSuccess(productslot, roomId));
  } catch (err) {
    dispatch(productSlotCreateFailure(err));
  }
};

export const updateProductSlot = (id: number, body: any) => async (dispatch: Dispatch<ConfigTemplateAction>) => {
  dispatch(productSlotUpdateRequest());
  try {
    const productslot = await PUT({
      endpoint: `/productslots/${id}`,
      body,
    }, dispatch);
    dispatch(productSlotUpdateSuccess(productslot));
  } catch (err) {
    dispatch(productSlotUpdateFailure(err));
  }
};

export const updateRooms = (configId: number, roomId: number, sortDirection: 'up' | 'down') => async (dispatch: Dispatch<ConfigTemplateAction>) => {
  dispatch(roomsUpdateRequest());
  try {
    const rooms = await PUT({
      endpoint: `/configtemplates/${configId}/rooms`,
      body: {
        roomId,
        sortDirection,
      },
    }, dispatch);
    dispatch(roomsUpdateSuccess(rooms));
  } catch (err) {
    dispatch(roomsUpdateFailure(err));
  }
};

export const updateProductSlots = (roomId: number, productSlotId: number, sortDirection: 'up' | 'down') => async (dispatch: Dispatch<ConfigTemplateAction>) => {
  dispatch(productSlotsUpdateRequest());
  try {
    const productSlots = await PUT({
      endpoint: `/rooms/${roomId}/productslots`,
      body: {
        productSlotId,
        sortDirection,
      },
    }, dispatch);
    dispatch(productSlotsUpdateSuccess(roomId, productSlotId, productSlots));
  } catch (err) {
    dispatch(productSlotsUpdateFailure(err));
  }
};



// WEBPACK FOOTER //
// ./src/actions/configTemplateView.js